module.exports = __webpack_public_path__ + "static/media/handQR.51a9ef3e.png";